import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import OpenAIFilledSvg from "@ant-design/icons-svg/es/asn/OpenAIFilled";
import AntdIcon from '../components/AntdIcon';
var OpenAIFilled = function OpenAIFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: OpenAIFilledSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(OpenAIFilled);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'OpenAIFilled';
}
export default RefIcon;